import React, { useState } from 'react';
import UserImage from '../user-image/user-image';
import ImageButton from '../image-button/image-button';

function ProfileImage({ primary = 1, onSetPrimary, handleSubmit }) {
    const [imageOne, setImageOne] = useState<string>();
    const [imageTwo, setImageTwo] = useState<string>();
    const [imageThree, setImageThree] = useState<string>();

    return (
        <div className="flex flex-row justify-start">
            <div className="flex-col p-4">
                <UserImage onSetPrimary={onSetPrimary} handleSubmit={handleSubmit} setImageOne={setImageOne} setImageTwo={setImageTwo} setImageThree={setImageThree} primary={primary} />
            </div>
            <div className="flex-col">
                <div className="-ml-8">
                    <ImageButton image={imageOne} onClick={() => onSetPrimary(1)} selected={1 === primary} />
                </div>
                <ImageButton image={imageTwo} onClick={() => onSetPrimary(2)} selected={2 === primary} />
                <div className="-ml-8">
                    <ImageButton image={imageThree} onClick={() => onSetPrimary(3)} selected={3 === primary} />
                </div>
            </div>
        </div>
    );
}

export default ProfileImage;
